/**
 * Element.remove() polyfill for Internet Explorer 9+
 * Matches jQuery.remove()
 *
 * source: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
 * usage: https://caniuse.com/#feat=childnode-remove
 */

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
